function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22 14.9v8.2c0 .4-.3.8-.8.8H4.8c-.4 0-.8-.3-.8-.8v-8.2c0-.4.3-.8.8-.8s.8.3.8.8v7.5h15v-7.5c0-.4.3-.8.8-.8s.6.4.6.8zM9.5 18.5L12 16l1.1 1.1c.5.5 1.3.5 1.8 0l2.6-2.6c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L14 15.9l-1.1-1.1c-.5-.5-1.3-.5-1.8 0l-2.6 2.6c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4 0 .5-.2zm15.3-5.6L14.6 2.7c-.8-.8-2.3-.8-3.2 0L1.2 12.9c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2L12.5 3.8c.3-.3.8-.3 1.1 0L23.7 14c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1z"
})));